import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { LuxePerspective } from "@/components/perspective/LuxePerspective";
import { PropertyCard } from "@/components/PropertyCard";
import { PropertySearch } from "@/components/PropertySearch";
import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/seed";

export default function Luxe() {
  const { data } = useApp();
  const properties = data.properties.filter((p) => p.published && p.category.includes("luxe")).slice(0, 6);

  return (
    <div style={{ background: "#071711" }} className="text-[#F5F3ED]">
      <section className="relative min-h-screen overflow-hidden">
        <div className="absolute inset-0">
          <img src={IMAGES.luxeHero} alt="Luxe" className="h-full w-full object-cover" />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(5,15,12,0.7), rgba(5,15,12,0.97))" }} />
        </div>
        <div className="hero-copy container-arch relative flex min-h-screen flex-col justify-center pt-24">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} className="max-w-3xl">
            <div className="overline !text-[#9ED3B8]">Archedia Luxe · For the standard you choose to live by</div>
            <h1 className="mt-5 font-serif text-4xl font-light leading-[1.1] sm:text-6xl lg:text-7xl">Some Properties Are Bought. Others Are <span className="gold-gradient-text italic">Chosen.</span></h1>
            <Link to="/request?purpose=Luxury" className="btn-gold mt-9 !bg-[var(--accent-gold)] !text-[#071711]">Enter Archedia Luxe <ArrowUpRight className="h-4 w-4" /></Link>
          </motion.div>
        </div>
      </section>

      <section className="container-arch relative z-20 -mt-8" data-testid="vertical-search">
        <div className="arch-card p-3 sm:p-4"><PropertySearch /></div>
      </section>

      <section className="container-arch py-24">
        <Reveal><div className="overline">The Luxe Perspective</div>
          <h2 className="mt-3 max-w-2xl font-serif text-3xl font-light sm:text-4xl">A different standard of evaluation.</h2>
        </Reveal>
        <div className="mt-14"><LuxePerspective /></div>
      </section>

      {properties.length > 0 && (
        <section className="container-arch pb-28">
          <Reveal><div className="overline">The Luxe collection</div><h2 className="mt-3 font-serif text-3xl font-light sm:text-4xl">Exceptional, by evaluation</h2></Reveal>
          <div className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {properties.map((p, i) => <PropertyCard key={p.id} property={p} index={i} />)}
          </div>
        </section>
      )}
    </div>
  );
}
